export default {"src":"/_next/static/media/calendar-colorful.65269f49.svg","height":65,"width":64};